import { render, staticRenderFns } from "./AccountsReceivable.vue?vue&type=template&id=3c58ec6b&scoped=true&"
import script from "./AccountsReceivable.vue?vue&type=script&lang=js&"
export * from "./AccountsReceivable.vue?vue&type=script&lang=js&"
import style0 from "./AccountsReceivable.vue?vue&type=style&index=0&id=3c58ec6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c58ec6b",
  null
  
)

export default component.exports